export default __webpack_public_path__ + "static/media/back-icon.a90cd566.svg";